<div class="overlay button-overlay"
     [hidden]="!isVisible"
     [ngStyle]="getStyle(isHoverState)"
     (click)="onClick($event)"
     (mouseenter)="toggleHoverState()"
     (mouseleave)="toggleHoverState()"
     [style.opacity]="opacity"
     [id]="overlay.uid"
     [style.left.%]="position.x"
     [style.top.%]="position.y"
     [attr.data-tracking-id]="overlay.reportingId"
>
    <span class="text" [innerHTML]="overlay.html | safeHtml"></span>
</div>
